// extracted by mini-css-extract-plugin
export var chevronIcon = "_4c-2";
export var teamName = "_4c-1";
export var teamSwitcherButton = "_4c-0";